import React, { useMemo } from "react";
import InterventionRow from "./InterventionRow";
import {
  Intervention,
  InterventionPlan,
} from "../../../../../../store/onboarding/cases/types";
import { Droppable } from "react-beautiful-dnd";
import { sortInterventionsByInterventionPlan } from "../../../../../utils";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";

type Props = {
  showIfNoData?: boolean;
  interventionGroupId: number;
  interventions: Intervention[];
  interventionPlan: InterventionPlan | null;
  isLoading?: boolean;
  urlTab?: string | null;
  isDragPermitted?: boolean;
  isFinished?: boolean;
  onRemoveIntervention?: (intervention: Intervention) => void;
};

const InterventionsList = ({
  showIfNoData,
  interventionGroupId,
  interventions,
  interventionPlan,
  isLoading,
  onRemoveIntervention,
  urlTab,
  isDragPermitted,
  isFinished
}: Props) => {
  const sortedInterventions = useMemo(
    () => sortInterventionsByInterventionPlan(interventions, interventionPlan),
    [interventionPlan, interventions]
  );

  if (showIfNoData && !sortedInterventions.length) {
    return <i>No Intervention Selected Yet</i>;
  }

  return (
    <div className="w-100 d-flex flex-column m-2">
      <SortableContext
        items={sortedInterventions.map((i) => i.id.toString())}
        strategy={verticalListSortingStrategy}
        disabled={(interventions.length <= 1) && (isFinished ? !isDragPermitted : false)}
      >
      {sortedInterventions.map((inter, index) => (
        <InterventionRow
          key={inter.id}
          intervention={inter}
          index={index}
          isLoading={isLoading || (urlTab && ['archived', 'exited_groups'].includes(urlTab)) || interventions.length <= 1}
          isDragPermitted={isDragPermitted}
          isFinished={isFinished}
          onRemove={onRemoveIntervention}
          interventionCount={interventions.length}
        />
      ))}
    </SortableContext>
  </div>
  );
};

export default InterventionsList;
